var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "19", height: "17", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.632 12.074H8.388l-.391-6.33c0-.5.675-.905 1.507-.905.832 0 1.507.405 1.507.904l-.379 6.33zm-.092 2.96c-.247.206-.593.31-1.037.31-.449 0-.8-.104-1.054-.31-.254-.206-.38-.492-.38-.86 0-.371.121-.66.367-.866.244-.206.6-.308 1.067-.308.462 0 .813.103 1.05.308.239.206.358.496.358.866 0 .368-.123.654-.37.86zm8.42.614L10.344.618C10.117.313 9.81 0 9.504 0c-.307 0-.613.312-.84.619L.032 15.675c-.082.316-.06.831.72 1.222h17.494c.805-.402.804-.936.714-1.25z", fill: "#D0021B", fillRule: "evenodd" })
  );
});